// This file is auto-generated by scripts/generate-revision.js
// Do not edit manually - changes will be overwritten on next build

export const REVISION = 'd327eab05 (EDUS-3273)';
export const VERSION = '0.16.12';
